import React from 'react';

interface AntiguaFlagProps {
  width?: number | string;
  height?: number | string;
  className?: string;
}

const AntiguaFlag: React.FC<AntiguaFlagProps> = ({ 
  width = '100%', 
  height = 'auto',
  className = '' 
}) => {
  // Calculate aspect ratio (138:92 = 1.5:1)
  const aspectRatio = 138 / 92;
  
  // If height is auto, calculate from width
  let finalWidth = width;
  let finalHeight = height;
  
  if (height === 'auto' && typeof width === 'number') {
    finalHeight = width / aspectRatio;
  } else if (height === 'auto' && typeof width === 'string') {
    // For percentage or other string values, use aspect ratio via CSS
    finalHeight = 'auto';
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 138 92"
      width={finalWidth}
      height={finalHeight}
      className={className}
      role="img"
      aria-label="Flag of Antigua and Barbuda"
      preserveAspectRatio="xMidYMid meet"
    >
      <title>Flag of Antigua and Barbuda</title>
      <path fill="#fff" d="m0 0h138v92H0z"/>
      <path d="m0 0h138l-9 46H9z"/>
      <path fill="#fcd116" d="m69 46-30-10 15.288-2.926-13.004-8.555 15.244 3.147-8.741-12.879 12.879 8.741-3.147-15.244 8.555 13.004L69 6l2.926 15.288L80.481 8.284 77.334 23.528l12.879-8.741-8.741 12.879 15.244-3.147-13.004 8.555L99 36z"/>
      <path fill="#0072c6" d="m9 36h120v20H9z"/>
      <path fill="#ce1126" d="m0 0 69 92 69-92v92H0z"/>
    </svg>
  );
};

export default AntiguaFlag;

